import type { EmployeeRole } from '../../../dashboard/management-panel/employees/common/enums/employee-role';

export enum SystemRole {
  SYSTEM_ADMIN = 'ROLE_SYSTEM_ADMIN',
}

export type UserRole = SystemRole | EmployeeRole;
